import * as React from "react";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ClickableElement from "../../utils/ClickableElement";

interface INewComponentLinkProps {
  onClick?: React.EventHandler<React.MouseEvent>;
  title: string;
}
const AddClickableElement = styled(ClickableElement)`
  padding-left: 0rem;
`;
const NewComponentLink: React.SFC<INewComponentLinkProps> = ({ onClick, title }) => (
  <Link to="#" onClick={onClick}>
    <AddClickableElement>
      <FaPlus />
      &nbsp;
      {title}
    </AddClickableElement>
  </Link>
);

export default NewComponentLink;
